import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import BlogTopic from "@/pages/BlogTopic";

// The guides surface — a content type, not a tag — lives at the site root.
export const Route = createFileRoute("/guides/")({
  // The library dataset is imported lazily so it stays out of the entry
  // bundle; only the small head fields are returned (they get serialized
  // into the SSR payload).
  loader: async () => {
    const { getSectionBySlug } = await import("@/data/library");
    const tag = getSectionBySlug("guides");
    if (!tag) throw notFound();
    return {
      title: tag.seoTitle ?? `${tag.name} | Bigdelta`,
      description: tag.blurb,
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: "/guides",
    });
  },
  component: () => <BlogTopic surfaceSlug="guides" />,
});
